<template>
	<div>
		<div>
			<div style="display: flex; justify-content: space-between">
				<el-row>
					<div class="page-body">
						<div style="display: flex; justify-content: space-between">
							<div>
								<el-button type="primary" icon="el-icon-plus" @click="showAdd">新增</el-button>
							</div>
						</div>
					</div>
				</el-row>
			</div>
		</div>

		<!-- 表格 start -->
		<div style="margin-top: 30px">
			<el-table :data="agentList" stripe border v-loading="loading" element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
				style="width: 100%">
				<el-table-column type="selection" align="center" width="44"></el-table-column>

				<el-table-column prop="agentName" label="名称" width="200" align="center"></el-table-column>
				<!-- <el-table-column prop="agentCode" label="编码 " align="center"></el-table-column> -->
				<el-table-column prop="platformNames" label="已选平台" align="center"></el-table-column>
				<el-table-column prop="stationNames" label="已选站点"  align="center"></el-table-column>
				<!-- <el-table-column prop="pushType" label="推送类型 " align="center"></el-table-column> -->
				<el-table-column prop="createdTime" label="创建时间" width="120" align="center"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button @click="showEditDialog(scope.row)">配置站点</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex; justify-content: flex-end">
				<el-pagination background @current-change="currentChange" @size-change="sizeChange"
					layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total"></el-pagination>
			</div>
		</div>
		<!-- 表格 END -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="800px">
			<div style="height: 40vh; overflow: auto">
				<!-- <el-form :model="addStationForm" ref="orderDetail" label-position="right" label-width="620px"> -->
				<el-col :span="22">
					<el-select style="width: 85%" multiple filterable v-model="addStationForm.stationIds"
						placeholder="请选择" @change="stationIdChange">
						<el-option v-for="item in stationIdOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-col>
				<!-- </el-form> -->
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doUpdate">确 定</el-button>
			</span>
		</el-dialog>


		<el-dialog :title="agentTitle" :visible.sync="dialogAgentVisible" width="800px">
			<div style="height: 40vh; overflow: auto">
				<el-form :model="form" :rules="formRules" ref="formRef" label-position="right" label-width="150px"
					size="800px">
					<el-row>
						<el-form-item label="推送平台:" prop="platformName">
							<el-select style="width: 70%" multiple filterable v-model="addStationForm.platformIds"
								placeholder="请选择" @change="platformIdChange">
								<el-option v-for="item in platformIdOptions" :key="item.value" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="代理商名称:" prop="agentName">
								<el-input size="mini" style="width: 70%" prefix-icon="el-icon-edit"
									v-model="addStationForm.agentName" placeholder="请输入代理商名称"></el-input>
							</el-form-item></el-col>

					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="配置站点:" prop="stationNames">
								<el-select style="width: 85%" multiple filterable v-model="addStationForm.stationIds"
									placeholder="请选择" @change="stationIdChange">
									<el-option v-for="item in stationIdOptions" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>

					</el-row>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogAgentVisible = false">取 消</el-button>
				<el-button type="primary" @click="doSaveChargeAgent">确 定</el-button>
			</span>
		</el-dialog>


	</div>
</template>

<script>
	import {
		Message
	} from "element-ui";
	import {
		apiListStations,
		apiAddChargeAgentStation,
		apiGetChargeAgent,
		apiSaveChargeAgent,
		apiListChargeAgent,
		apiListPushPlatform
	} from "./charge-agent";
	import {
		deleteRequest,
		putRequest,
		getRequest,
		postRequest,
	} from "../../utils/api";
	export default {
		name: "OrderList",
		data() {
			return {
				title: "配置推送站点", //模态窗口 标题
				agentTitle: '代理商管理',
				searcheForm: {
					stationIds: null
				}, //搜索
				agentList: [], //列表数据
				rolesOptions: [],
				loading: false,
				dialogVisible: false, // 是否显示 模态窗
				stationIdOptions: [],
				platformIdOptions: [],
				addStationForm: {
					agentId: null,
					agentName: null,
					stationIds: new Array(),
					platformIds:new Array()
				},
				dialogAgentVisible: false,
				form: {
					agentId: null,
					agentName: null,
					agentCode: null,
					platformName: null,
					platformId: null,
					platformIds: []

				},
				formRules: {},
				total: 0,
				page: 1,
				size: 10,
				platformList: [],
			};
		},
		mounted() {
			this.initPageData();
			this.initSelectStations();
			this.initSelectPlatform()
		},
		methods: {
			showAdd() {
				this.addStationForm = {};
				this.dialogAgentVisible = true;
				// this.initSelectPlatform()
				// this.initSelectStations()
			},
			doSaveChargeAgent() {

				const data = this.addStationForm;

				console.dir(data);

				apiSaveChargeAgent(data).then((resp) => {
					console.log('========apiSaveChargeAgent============')
					console.dir(resp)
					Message.success({
						message: '操作成功'
					});
					this.dialogAgentVisible =false;
					this.initPageData();
				})



			},
			// 页大小
			sizeChange(currentSize) {
				this.size = currentSize;
				this.list();
			},
			// 选择页
			currentChange(currentPage) {
				this.page = currentPage;
				this.list("advanced");
			},
			clearForm() {
				this.searcheForm = {};
			},
			platformIdChange() {
				this.$forceUpdate()
			},
			stationIdChange(v) {
				this.$forceUpdate()
			},
			doUpdate() {
				const agentCode = this.addStationForm.agentCode;
				const name = this.addStationForm.agentName;
				let stations = new Array();
				let stationIds = this.addStationForm.stationIds;
				this.stationIdOptions.forEach(station => {
					stationIds.forEach(v => {
						if (v === station.value) {
							const tempStation = {
								stationId: station.value,
								stationName: station.label,
								pushDestinationCode: agentCode,
								pushDestinationName: name,
								enabled: "Y",
								destinationType: "agent"
							}
							stations.push(tempStation);
						}
					})
				})
				// const agentStation = { stationList: stations, }
				console.dir(stations)
				apiAddChargeAgentStation(stations).then((resp) => {
					consle('====='+resp)
					this.dialogVisible = false;
				});
			},
			initSelectStations() {

				apiListStations({
					page: 1,
					size: 9999
				}).then((resp) => {
					if (resp.status == 200) {
						const data = resp.data;
						this.stationList = data.list;
						this.stationList.forEach((element) => {
							this.stationIdOptions.push({
								label: element.stationName,
								value: element.id,
							});
						});
					}
				});
			},
			initSelectPlatform() {

				apiListPushPlatform().then((resp) => {
					this.loading = false;
					this.form = {};
					if (resp) {
						let _list = resp.data;
						
						_list.forEach(e => {
							this.platformIdOptions.push({
								label: e.name,
								value: e.id+""
							})
						})
						
					}

				});
				this.$forceUpdate()
			},
			
			showEditDialog(data) {
				// this.initSelectPlatform()
				this.addStationForm = {
					stationIds: new Array(),
					platformIds: new Array(),
					...data
				};
				apiGetChargeAgent(data.id).then((resp) => {
					const __refAccounts = resp.chargeAgentAccounts;
					__refAccounts.forEach(ra => {
						this.addStationForm.platformIds.push(ra.accountId+"")
					})
					const __refStations = resp.configPushLtStationList;
					__refStations.forEach(e => {
						this.addStationForm.stationIds.push(e.stationId)
					})
				})

				this.dialogAgentVisible = true
				this.$forceUpdate()

				// getRequest(
				// 	`/api/push-platform/list-station/` + data.agentCode, {}
				// ).then((resp) => {
				// 	this.loading = false;
				// 	if (resp) {
				// 		let _list = resp.data;
				// 		_list.forEach(e => {
				// 			this.addStationForm.stationIds.push(e.stationId)
				// 		})
				// 		this.$forceUpdate()
				// 		this.dialogAgentVisible = true;
				// 	}
				// })

			},
			//历史
			showSettingDialog(data) {
				this.$forceUpdate()
				this.addStationForm = {
					stationIds: new Array(),
					...data
				};
				getRequest(
					`/api/push-platform/list-station/` + data.agentCode, {}
				).then((resp) => {
					this.loading = false;
					if (resp) {
						let _list = resp.data;
						_list.forEach(e => {
							this.addStationForm.stationIds.push(e.stationId)
						})
						this.$forceUpdate()
						this.dialogVisible = true;
					}
				})

			},
			// 查询用户列表
			initPageData(type) {
				this.loading = true;
				const data = {
					page: 1,
					size: 10
				};
				apiListChargeAgent(data).then((resp) => {
					this.loading = false;
					if (resp) {
						this.agentList = resp;
					}
				});
			}
		},
	};
</script>

<style>
	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
		transition: all 0.8s ease;
	}

	.slide-fade-leave-active {
		transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
	}

	.slide-fade-enter,
	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateX(10px);
		opacity: 0;
	}
</style>